export type IDoUnblockUI = (target: IjQueryElmOrHtmlElm) => void;

export function doUnblockUI(target: IjQueryElmOrHtmlElm) {
  if (target) {
    ($(target) as any).unblock({
      onUnblock() {
        $(target).css('position', '');
        $(target).css('zoom', '');
      },
    });
  } else {
    ($ as any).unblockUI();
  }
}
